var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from "@i18n";
import { CDN_LINK } from '@globalConfig';
var PromiseBannerSection = function PromiseBannerSection() {
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("section", {
    className: "mt-[117px] md:mt-[100px] mb-8 mb:my-[71px] px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto bg-[#00B362] rounded-[16px] text-center md:max-w-[953px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative py-10 text-white min-h-[173px] flex flex-col justify-center md:p-15 md:min-h-[282px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute -top-[95px] left-1/2 transform -translate-x-1/2 md:-top-[90px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/sell-trade/Image.svg",
    alt: "Sell Your Car",
    className: "w-[197px] h-[197px]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pt-10 md:pt-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[18px] font-medium mb-3 leading-[1.5] md:text-[32px] md:mb-4"
  }, tShort('promise_banner/subtitle', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("h2", {
    className: "text-[28px] font-bold leading-[1.3] md:text-[48px]"
  }, tShort('promise_banner/title', {
    ns: 'web_sell_trade'
  }))))));
};
export default PromiseBannerSection;